/*
 * @Author: zhaofy
 * @Date: 2018-02-8 22:55:56
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-03-11 16:58:09
 */
<template>
  <!-- 支付回调页面 -->
  <div class="pay-result">
    <div class="cart-nav">
      <img src="//static.kxymall.com/images/pay.jpg" alt="购物车及购物车进程">
    </div>
    <div class="encircle">
      <h1>支付状态</h1>
      <div class="deliver">
        <div style="width:100px;">
          <img style="width:93px;height:105px" src="//static.kxymall.com/images/gth.jpg" alt="支付失败">
        </div>
        <div style="width:700px;">
          <div class="order-list" @click="backOrder()">支付失败！返回我的订单</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'payError',
  created() {
  },
  data() {
    return {
    }
  },
  methods: {
    backOrder() {
      this.$router.push({ path: '/member/order' });
    }
  }
}
</script>
<style lang="less" scoped>
.pay-result {
  width: 980px;
  overflow: hidden;
  margin: 0px auto;
}
.cart-nav {
  width: 980px;
  height: 69px;
  overflow: hidden;
  border-top: 1px solid #e7e8e4;
  image {
    width: 980px;
    height: 69px;
  }
}
.encircle {
  margin: 10px 0px;
  background: #f0f1f5;
  h1 {
    width: 943px;
    height: 34px;
    font-size: 1em;
    line-height: 34px;
    color: #fff;
    font-weight: normal;
    padding-left: 33px;
    background-color: #49a9cf;
  }
}
.deliver {
  width: 907px;
  height: 89px;
  padding: 14px 0px 17px 69px;
  overflow: hidden;
  > div {
    float: left;
    display: inline;
    img {
      width: 93px;
      height: 89px;
      float: left;
      display: inline;
      margin-right: 65px;
    }
    .order-list {
      cursor: pointer;
      font-size: 12px;
      vertical-align: middle;
      letter-spacing: normal;
      word-spacing: normal;
      display: inline-block;
      width: 220px;
      height: 15px;
      margin: 5px 0 0 5px;
      font-weight: bold;
      color: #08c;
    }
  }
}
</style>







// WEBPACK FOOTER //
// payError.vue?961f84e0